var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { Pane, Text, toaster, } from "evergreen-ui";
import spinner from "../assets/transparent_favicon.png";
import { ErrorBoundary, DropZone } from "../Misc";
// import { Loading, useMatchMedia } from './Misc'
// import dxf from '../assets/dxf.png';
import { FolderList, Folder } from "./Folders";
import { useLibrary } from "../Api/Library/Provider";
export * from "../Api/Library/Provider";
import * as Sentry from "@sentry/react";
//https://www.flaticon.com/packs/file-types-25
//Todo licence or other file
// export let FileIcon = (props: { ext: string; }) => {
//     if (props.ext.toLowerCase() == 'dxf') {
//         return <img src={dxf} height={40}
//             title={props.ext}
//             style={{ marginRight: 8 }} />
//     }
//     return <Avatar
//         name={props.ext}
//         size={40}
//         marginRight={8} />
// }
export function Library(props) {
    document.title = "DuraProducts";
    const [file, setFile] = React.useState(null);
    const Library = useLibrary();
    const [busy, setBusy] = React.useState(false);
    if (!Library)
        return React.createElement(React.Fragment, null, "No Library Context");
    React.useEffect(() => {
        if (file && props.selectedFolder) {
            if (file.folder != props.selectedFolder.key) {
                setFile(null);
            }
        }
        setBusy(false);
    }, [props.selectedFolder]);
    let newFolder = (v) => {
        return Library.newFolder(v, props.selectedFolder).then((b) => {
            props.setSelectedFolder && props.setSelectedFolder(b);
        });
    };
    let deleteFolder = (folder) => {
        let p = (folder.folder || Library.items[0]);
        return Library.deleteFolder(folder).then(() => {
            props.setSelectedFolder && props.setSelectedFolder(p);
        });
    };
    let HandleFileUpload = ((_file) => {
        if (!Array.isArray(_file))
            _file = [_file];
        let files = _file.map((file) => __awaiter(this, void 0, void 0, function* () {
            if (!file)
                return console.log("No file", file);
            let fullpath = props.selectedFolder.path();
            fullpath.push(file.name);
            setBusy(true);
            const res = yield Library.uploadFile(file, fullpath);
            Sentry.addBreadcrumb({
                category: "Library",
                message: "Post Uploading new file ",
                level: "info",
                data: {
                    file: file,
                    fullpath: fullpath,
                    res: res,
                },
            });
            if (!res)
                return toaster.danger("There seems to be a problem with the upload, Please try again");
            return file;
        }));
        Promise.all(files).then((res) => {
            Library.reloadLibrary();
        });
    }).bind(this);
    React.useEffect(() => {
        if (Library.items && Library.items.length > 0) {
            props.setSelectedFolder(!props.selectedFolder
                ? Library.items[0]
                : Library.items[Library.indexFromPath(props.selectedFolder.path())]);
        }
    }, [Library.items]);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Pane, { display: "flex", flex: 1, style: { height: "99%" }, id: "folderParent" },
            React.createElement(Pane, { clearfix: true, padding: 8, alignItems: "left", display: "flex", width: 300, flexDirection: "column", background: "blueTint", style: { height: "100%" } }, Library.items && Library.items.length > 0 && (React.createElement(FolderList, { readonly: true, key: Library.items[0].key, open: true, library: Library.items, folder: Library.items[0], selectedFolder: props.selectedFolder, selectFolder: props.setSelectedFolder, deleteFolder: deleteFolder, newFolder: (v) => {
                    newFolder(v);
                }, onAddNewOrder: props.onAddNewOrder }))),
            React.createElement(Pane, { style: { width: "100%" } }, busy ? (React.createElement(Pane, { background: "white", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "10px" },
                React.createElement(Pane, { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px" },
                    React.createElement("img", { src: spinner, width: "100px", className: "rotate" }),
                    React.createElement(Text, null,
                        React.createElement("h1", null, "Uploading..."))))) : (React.createElement(Pane, { height: "100%", display: "flex", flexDirection: "column-reverse", background: "#f3f6ff" },
                React.createElement(DropZone, { onChange: HandleFileUpload }),
                props.selectedFolder && (React.createElement(Folder, { folder: props.selectedFolder, library: Library.items, onClick: (file) => {
                        props.onAddNewOrder(file);
                        setFile(null);
                    } }))))))));
}
